import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AESDecrypt } from '../../../encrypt-util';
import { useSelector } from 'react-redux';
import { RootState } from '../template/store';
import { useState, useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { Button, Card, Form } from 'react-bootstrap';
import { updateRowColumns } from './UserDetailsSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../template/store';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { updateToggle, updateUserDetailsList } from './UserDetailsSlice';
import { faFloppyDisk } from '@fortawesome/free-regular-svg-icons';
import { getUnprefixedPathname } from '../../../helpers/utils';
import {
  saveUserDetails,
  addUserFromDashboard,
  getAllUserDetailsByUser,
} from './action/UserDetails';
import { getGroupbyTypes } from '../customerMappingDashboard/MappingActions';
import { useTranslation } from 'react-i18next';
import { getUserProfile } from '../../common/actions/userDetails';
import { updateDashbaordRefresh } from '../../common/components/DataTable/slices/DataTable';
import { useBackNavigation } from '../../../hooks/BackNavigation';
import { useFormNavigationWarning } from '../../../hooks/useFormNavigationWarning';
import UnsavedChangesModal from '../../../components/common/UnsavedChangesModal';
import { setDirty } from '../formDirtySlice';
import useDataCountry from '../../../hooks/useDataCountry';
import { AccountStatus, AccountStatusLabel } from '../../constants/userStatus';

// Add prop type for setIsFormDirty
interface UserProps {
  setIsFormDirty?: (dirty: boolean) => void;
}

const buildUserSnapshot = (source?: any) => {
  const isNewUserRecord = source?.mstUsrId === null || source?.mstUsrId === undefined || source?.mstUsrId === '';
  return {
    loginId: source?.loginId ?? '',
    title: source?.title ?? 'Mr.',
    usrNm: source?.usrNm ?? '',
    contactNo: source?.contactNo ?? '',
    contactPerson: source?.contactPerson ?? '',
    mstGrp: (source?.mstGrp ?? []).map((v: any) => ({
      value: v?.mstGrpId ?? v?.value,
      label: v?.usrGrpNm ?? v?.label,
    })),
    status: String(source?.status ?? (isNewUserRecord ? AccountStatus.PENDING_VERIFICATION : AccountStatus.ACTIVE)),
  };
};

const User: React.FC<UserProps> = ({ setIsFormDirty }) => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const userDetails = useSelector((state: RootState) => state.userList);
  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );
  const dataCountry = useDataCountry();
  const { userID } = useParams();
  const navigate = useNavigate();

 //User Id
 const [loginId, setLoginId] = useState('');

 //Title
 const [title, setTitle] = useState('');

 //User Name
 const [usrNm, setUsrNm] = useState('');

 //Contact Number
 const [contactNo, setContactNo] = useState('');

 //Contact Person
 const [contactPerson, setContactPerson] = useState('');

 const [groupList, setGroupList] = useState([]);

 const isNewUser = AESDecrypt(userID?.toString()).toString() === '0';
 const [status, setStatus] = useState(String(isNewUser ? AccountStatus.PENDING_VERIFICATION : AccountStatus.ACTIVE));
 const [countryAccess, setCountryAccess] = useState('');
 const [locationAccess, setLocationAccess] = useState('');

 const [disableFields, setDisableFields] = useState<any>(
   profileDetails?.partnerType === 'liner' ||
     (!!matchPath && profileDetails?.partnerType !== 'liner')
 );

 const [user, setUser] = useState<any>(
   AESDecrypt(userID?.toString()).toString() !== '0'
     ? {
         mstPartnerId: userDetails.data?.mstPartnerId,
         mstUsrId: null,
         loginId: '',
         usrNm: '',
         contactNo: '',
         title: 'Mr.',
         contactPerson: '',
         mstGrp: [],
         status: '',
         grpNm: '',
         countryShortCode: userDetails.data?.countryShortCode,
         countryName: userDetails.data.countryName,
         isRootUser: 'N',
         partnerNm: userDetails.data.partnerNm,
         countryAccess: '',
         locationAccess: '',
       }
     : userDetails?.data?.userData?.list?.find(
         (v: any) =>
           AESDecrypt(userID?.toString()).toString() === v.mstUsrId.toString()
       )
 );

 const [mstGrp, setMstGrp] = useState(
   user?.mstGrp?.map((c: any) => {
     return {
       value: c?.mstGrpId,
       label: c?.usrGrpNm,
     };
   }) ?? []
 );

 const [initialSnapshot, setInitialSnapshot] = useState<any>(null);

 const currentFormSnapshot = {
   loginId,
   title,
   usrNm,
   contactNo,
   contactPerson,
   mstGrp: mstGrp?.map((v: any) => ({ value: v?.value ?? v?.mstGrpId, label: v?.label ?? v?.usrGrpNm })) ?? [],
   status: String(status ?? (isNewUser ? AccountStatus.PENDING_VERIFICATION : AccountStatus.ACTIVE)),
 };
 const isDirty = initialSnapshot !== null && JSON.stringify(currentFormSnapshot) !== JSON.stringify(initialSnapshot);
 const currentStatusValue = user?.status != null && user.status !== '' ? String(user.status) : String(status ?? (isNewUser ? AccountStatus.PENDING_VERIFICATION : AccountStatus.ACTIVE));
 const normalizedCurrentStatusValue = String(currentStatusValue ?? (isNewUser ? AccountStatus.PENDING_VERIFICATION : AccountStatus.ACTIVE));
  type FormValues = {
    loginId: string;
    title: string;
    usrNm: string;
    contactNo: string;
    contactPerson: string;
    mstGrp: [];
    status: string;
  };

  const { t } = useTranslation();
  const validationSchema = Yup.object().shape({
    loginId: Yup.string().required(
      t('resource_3:isRequired', { field: 'User ID' })
    ),
    title: Yup.string().required(
      t('resource_3:isRequired', { field: 'Title' })
    ),
    usrNm: Yup.string().required(
      t('resource_3:isRequired', { field: 'User Name' })
    ),
    mstGrp: Yup.array().min(1, 'Pick at least 1 group'),
  });

  //Setup
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm<FormValues>({
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  });
  
 const onBack = useBackNavigation();

const { showModal, handleNavigation, handleConfirm, handleCancel, handleBack } = useFormNavigationWarning({
  isChanged: isDirty,
  isEditable: true,
  onConfirm: onBack  // or onBack, or your navigation function
});
  
    const handleStayOnPage = () => {
      handleCancel();
    };
  


  const handleLeavePage = () => {
   navigate(`${APP_PATH_PREFIX}/users`);
  };
  const onSubmit = handleSubmit(async (payload) => {
    try {
      const finalList =
        user.mstUsrId === null
          ? [
              {
                mstPartnerId: userDetails.data?.mstPartnerId,
                mstUsrId: null,
                loginId: loginId,
                usrNm: usrNm,
                contactNo: contactNo,
                title: title,
                contactPerson: contactPerson,
                grpNm: mstGrp?.map((u: any) => u.label).join(','),
                mstGrp: mstGrp.map((g: any) => {
                  return {
                    mstGrpId: g.value,
                    usrGrpNm: g.label,
                    locationAccess: locationAccess,
                    countryAccess: countryAccess,
                  };
                }),
                status: status,
                countryShortCode: dataCountry || userDetails.data?.countryShortCode,
                countryName: userDetails.data.countryName,
                isRootUser: 'N',
                partnerNm: userDetails.data.partnerNm,
                countryAccess: countryAccess,
                locationAccess: locationAccess,
              },
            ].concat(userDetails.data?.userData?.list?.map((v: any) => v) || [])
          : (userDetails.data?.userData?.list || []).map((v: any) => {
              if (user.mstUsrId === v.mstUsrId) {
                return {
                  ...v,
                  loginId: loginId,
                  usrNm: usrNm,
                  contactNo: contactNo,
                  title: title,
                  contactPerson: contactPerson,
                  grpNm: mstGrp?.map((u: any) => u.label).join(','),
                  partnerNm: userDetails.data.partnerNm,
                  mstGrp: mstGrp.map((g: any) => {
                    return {
                      mstGrpId: g.value,
                      usrGrpNm: g.label,
                      locationAccess: locationAccess,
                      countryAccess: countryAccess,
                    };
                  }),
                  status: status,
                  countryShortCode: dataCountry || user?.countryShortCode || userDetails.data?.countryShortCode,
                  countryAccess: countryAccess,
                  locationAccess: locationAccess,
                };
              } else {
                return v;
              }
            });

      const response = await dispatch(
        addUserFromDashboard({
          mstPartnerId: user.mstPartnerId,
          mstUsrId: user.mstUsrId,
          loginId: loginId.toLocaleLowerCase(),
          usrNm: usrNm,
          contactNo: contactNo,
          title: title,
          contactPerson: contactPerson,
          grpNm: mstGrp?.map((u: any) => u.label).join(','),
          mstGrp: mstGrp.map((g: any) => {
            return {
              mstGrpId: g.value,
              usrGrpNm: g.label,
            };
          }),
          status: isNewUser ? AccountStatus.PENDING_VERIFICATION : Number(status),
          countryShortCode: dataCountry || user?.countryShortCode || userDetails.data?.countryShortCode,
          countryName: userDetails.data.countryName,
          isRootUser: user.isRootUser,
          partnerNm: userDetails.data.partnerNm,
          countryAccess: countryAccess,
          locationAccess: locationAccess,
        })
      ).unwrap();

      if (!response || response.error) {
        const errorMessage = response?.responseMsg || response?.successMessage || 'Please Try Again';
        toast.error(errorMessage);
        return;
      }

      const successMessage = response.isNewUser
        ? 'User added. A verification link has been sent to their email.'
        : response.responseMsg?.toString() || 'User details saved successfully.';
      toast.success(successMessage);
      dispatch(
        updateToggle({
          ...userDetails,
          toggle: true,
        })
      );
      dispatch(
        updateUserDetailsList({
          ...userDetails.data?.userData,
          list: finalList,
        })
      );
      dispatch(updateDashbaordRefresh(true));
      navigate(`${APP_PATH_PREFIX}/users`);
    } catch (err: any) {
      toast.error(err?.response?.data?.responseMsg || err?.message || 'Please Try Again');
    }
  });

  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
  useEffect(() => {
    if (!user) return;
    setInitialSnapshot(buildUserSnapshot(user));
    if (matchPath(`${APP_PATH_PREFIX}/users/details/:userID`, getUnprefixedPathname())) {
      setLoginId(user?.loginId ?? '');
      setValue('loginId', user?.loginId ?? '');
      setTitle(user?.title ?? 'Mr.');
      setValue('title', user?.title ?? 'Mr.');
      setUsrNm(user?.usrNm ?? '');
      setValue('usrNm', user?.usrNm ?? '');
      setContactNo(user?.contactNo ?? '');
      setValue('contactNo', user?.contactNo ?? '');
      setContactPerson(user?.contactPerson ?? '');
      setValue('contactPerson', user?.contactPerson ?? '');
      const nextMstGrp = (user?.mstGrp ?? []).map((v: any) => ({ value: v?.mstGrpId ?? v?.value, label: v?.usrGrpNm ?? v?.label }));
      setMstGrp(nextMstGrp);
      setValue('mstGrp', nextMstGrp);
      const currentStatus = user?.status ?? AccountStatus.ACTIVE;
      const normalizedStatus = String(currentStatus);
      setStatus(normalizedStatus);
      setValue('status', normalizedStatus);
      setCountryAccess(
        Array.isArray(user?.countryAccess)
          ? user.countryAccess.join(',')
          : (user?.countryAccess ?? '')
      );
      setLocationAccess(
        user?.locationAccess ?? user?.mstGrp?.[0]?.locationAccess ?? ''
      );
      dispatch(getGroupbyTypes({
        country: dataCountry,
        type:String(profileDetails.partnerType?.toUpperCase()),
      }))
        .unwrap()
        .then((response: any) => {
          setGroupList(
            response.map((v: any) => {
              return {
                label: v?.label ?? v?.usrGrpNm,
                value: v?.value ?? v?.mstGrpId,
              };
            })
          );
        });
    }
  }, [user, dataCountry, profileDetails.partnerType, dispatch]);

  useEffect(() => {
    if (matchPath(`${APP_PATH_PREFIX}/users/details/:userID`, getUnprefixedPathname())) {
      dispatch(
        updateRowColumns({
          mainTableClass: 'col-lg-2',
          outletClass: 'col-lg-10',
        })
      );
      if (AESDecrypt(userID?.toString()).toString() === '0') {
        const nextUser = {
          mstPartnerId: userDetails.data?.mstPartnerId,
          mstUsrId: null,
          loginId: '',
          usrNm: '',
          contactNo: '',
          title: 'Mr.',
          contactPerson: '',
          mstGrp: [],
          status: '',
          countryShortCode: userDetails.data?.countryShortCode,
          isRootUser: 'N',
          partnerNm: userDetails.data.partnerNm,
          countryAccess: '',
          locationAccess: '',
        };
        setUser(nextUser);
        setInitialSnapshot(buildUserSnapshot(nextUser));
        setDisableFields(false);
      } else {
        setDisableFields(true);
        dispatch(getUserProfile())
          .unwrap()
          .then((response: any) => {
            const partnerId = response?.data?.partnerId;
            const usrId = response?.data?.userId;
            dispatch(
              getAllUserDetailsByUser({
                partnerId,
                usrId,
              })
            )
              .unwrap()
              .then((userListResponse: any) => {
                const nextUser = (userListResponse?.userData?.list ?? []).find(
                  (v: any) =>
                    AESDecrypt(userID?.toString()).toString() ===
                    v.mstUsrId.toString()
                ) ?? userDetails.data.userData.list.find(
                  (v: any) =>
                    AESDecrypt(userID?.toString()).toString() ===
                    v.mstUsrId.toString()
                );
                setUser(nextUser);
                setInitialSnapshot(buildUserSnapshot(nextUser));
              });
          });
      }
      // convert group list to dropdown list
      setMstGrp(
        user?.mstGrp?.map((v: any) => {
          return {
            value: v?.mstGrpId,
            label: v?.usrGrpNm,
          };
        })
      );
    } else if (matchPath(`${APP_PATH_PREFIX}/users`, getUnprefixedPathname())) {
      dispatch(
        updateRowColumns({
          mainTableClass: 'col-lg-12',
          outletClass: 'd-none',
        })
      );

      navigate(`${APP_PATH_PREFIX}/users`);
    }
  }, [location.pathname]);

  // After useForm, sync isDirty to parent
  useEffect(() => {
    if (setIsFormDirty) setIsFormDirty(isDirty);
  }, [isDirty, setIsFormDirty]);

  return (
    <div className=' h-100'>
      
                  <UnsavedChangesModal
              show={showModal}
              onHide={handleStayOnPage}
              onConfirm={handleLeavePage}
            />
      <Form onSubmit={onSubmit} autoComplete='off'>
        <div>
          <div className='row'>
            <div className='col-lg-6 '>
              <Form.Group controlId='user.loginId'>
                <Form.Label className='fs--1 '>
                  <span className='mandatory'>*</span>
                  {t("resource_3:userEmailId")} 
                </Form.Label>
                <Form.Control
                  {...register('loginId')}
                  className={`fs--1 form-control textTransform ${
                    errors.loginId ? 'is-invalid' : ''
                  }`}
                  type='text'
                  onChange={(e) => {

                    setLoginId(e.target.value.replaceAll(' ',''));
                    //_onAccountAliasChange(e.target.value);
                    setValue('loginId', e.target.value.replaceAll(' ',''));
                              dispatch(setDirty());
                  }}
                  onBlur={(e) => {
                    if (loginId !== '') {
                      setValue('loginId', e.target.value,{shouldDirty:true});
                    }
                  }}
                  size='sm'
                  maxLength={200}
                  value={loginId}
                  disabled={AESDecrypt(userID?.toString()).toString() !== '0' }
                />
                <div className='invalid-feedback'>
                  {errors.loginId?.message?.toString()}
                </div>
              </Form.Group>
            </div>
            <div className='col-lg-6 '>
              <Form.Group controlId='user.usrNm'>
                <Form.Label className='fs--1 '>
                  <span className='mandatory'>*</span>
                  {t("resource_2:userName")}
                </Form.Label>
                {/*<div className='col-lg-4 mb-2'>
                                    <Form.Select
                                        {...register('title')}
                                        className={`fs--1 form-control ${
                                        errors.title ? 'is-invalid' : ''
                                        }`}
                                        value={title}
                                        onChange={(e) => { 
                                            setTitle(e.target.value);
                                            setValue('title', e.target.value);
                                            }}>
                                        <option value='Mr.'  >Mr</option>
                                        <option value='Mrs.' >Mrs</option>
                                    </Form.Select>
                                        </div>
                                <div className='col-lg-8 '>*/}
                <Form.Control
                  {...register('usrNm')}
                  className={`fs--1 form-control ${
                    errors.usrNm ? 'is-invalid' : ''
                  }`}
                  type='text'
                  maxLength={200}
                  onChange={(e) => {
                    setUsrNm(e.target.value);
                    setValue('usrNm', e.target.value);
                              dispatch(setDirty());
                    //_onAccountAliasChange(e.target.value);
                  }}
                  onBlur={(e) => {
                    if (usrNm !== '') {
                      setValue('usrNm', e.target.value,{shouldDirty:true});
                    }
                  }}
                  size='sm'
                  value={usrNm}
                />
                {/*</div>*/}

                <div className='invalid-feedback'>
                  {errors.title?.message?.toString()}
                  {errors.usrNm?.message?.toString()}
                </div>
              </Form.Group>
            </div>
            {/*For now hidding contact number and contact person <div className='col-lg-6 mb-3'>
                            <Form.Group controlId='user.contactNo'>
                                <Form.Label className='fs--1 '>
                                    <span className='mandatory'>*</span>
                                    {'Contact Number'}
                                </Form.Label>
                                <Form.Control
                                    {...register('contactNo')}
                                    className={`fs--1 form-control ${
                                        errors.contactNo ? 'is-invalid' : ''
                                    }`}
                                    type='text'
                                    onChange={(e) => {
                                        setContactNo(e.target.value);
                                        //_onAccountAliasChange(e.target.value);
                                    }}
                                    onBlur={(e) => {
                                        if (contactNo !== '') {
                                        setValue('contactNo', e.target.value);
                                        }
                                    }}
                                    size='sm'
                                    value={contactNo}        
                                />
                                <div className='invalid-feedback'>
                                    {errors.contactNo?.message?.toString()}
                                </div>
                            </Form.Group>       
                        </div>
                        <div className='col-lg-6 mb-3'>
                            <Form.Group controlId='user.contactPerson'>
                                <Form.Label className='fs--1 '>
                                    <span className='mandatory'>*</span>
                                    {'Contact Person'}
                                </Form.Label>
                                <Form.Control
                                    {...register('contactPerson')}
                                    className={`fs--1 form-control ${
                                        errors.contactPerson ? 'is-invalid' : ''
                                    }`}
                                    type='text'
                                    onChange={(e) => {
                                        setContactPerson(e.target.value);
                                        //_onAccountAliasChange(e.target.value);
                                    }}
                                    onBlur={(e) => {
                                        if (contactPerson !== '') {
                                        setValue('contactPerson', e.target.value);
                                        }
                                    }}
                                    size='sm'
                                    value={contactPerson}        
                                />
                                <div className='invalid-feedback'>
                                    {errors.contactPerson?.message?.toString()}
                                </div>
                            </Form.Group>       
                                </div>*/}
            <div className='col-lg-6 ' style={{ zIndex: 999 }}>
              <Form.Label className='fs--1'>
                <span className='mandatory'>*</span>
                {t("resource_1:group")}
              </Form.Label>
              <Select
                {...register('mstGrp')}
                onChange={(u: any) => {
                  setMstGrp(u.map((v: any) => v));
                  setValue(
                    'mstGrp',
                    u.map((v: any) => v)
                  );
                            dispatch(setDirty());
                }}
                options={groupList}
                className={`fs--1  ${
                  errors.mstGrp?.toString ? 'is-invalid' : ''
                }`}
                noOptionsMessage={() => 'No group'}
                isMulti={true}
                autoFocus={true}
                isSearchable={true}
                value={mstGrp}
              />

              <div className='invalid-feedback'>
                {errors.mstGrp?.message?.toString()}
              </div>
            </div>
            {!isNewUser && <div className='col-lg-6 '>
              <Form.Group controlId='user.status'>
                <Form.Label className='fs--1'>
                  <span className='mandatory'>*</span>
                  {t("resource_1:status")}
                </Form.Label>
                <Form.Select
                  {...register('status')}
                  className={`fs--1 form-control ${
                    errors.status ? 'is-invalid' : ''
                  }`}
                  value={normalizedCurrentStatusValue}
                  disabled={![
                    String(AccountStatus.ACTIVE),
                    String(AccountStatus.INACTIVE),
                    String(AccountStatus.SUBMITTED),
                  ].includes(normalizedCurrentStatusValue) || isNewUser}
                  onChange={(e) => {
                    const nextStatus = e.target.value;
                    if (nextStatus === String(AccountStatus.INACTIVE) || nextStatus === String(AccountStatus.ACTIVE)) {
                      setStatus(nextStatus);
                      setValue('status', nextStatus);
                      dispatch(setDirty());
                    }
                  }}
                >
                  {![
                    String(AccountStatus.ACTIVE),
                    String(AccountStatus.INACTIVE),
                    String(AccountStatus.SUBMITTED),
                  ].includes(normalizedCurrentStatusValue) ? (
                    <>
                      <option value={normalizedCurrentStatusValue}>{AccountStatusLabel[Number(normalizedCurrentStatusValue)] ?? 'Current status'}</option>
                      <option value={String(AccountStatus.ACTIVE)}>{AccountStatusLabel[AccountStatus.ACTIVE]}</option>
                      <option value={String(AccountStatus.INACTIVE)}>{AccountStatusLabel[AccountStatus.INACTIVE]}</option>
                      <option value={String(AccountStatus.SUBMITTED)}>{AccountStatusLabel[AccountStatus.SUBMITTED]}</option>
                    </>
                  ) : (
                    <>
                      <option value={String(AccountStatus.ACTIVE)}>{AccountStatusLabel[AccountStatus.ACTIVE]}</option>
                      <option value={String(AccountStatus.INACTIVE)}>{AccountStatusLabel[AccountStatus.INACTIVE]}</option>
                    </>
                  )}
                </Form.Select>
                <div className='invalid-feedback'>
                  {errors.status?.message?.toString()}
                </div>
              </Form.Group>
            </div>}
            {/* <div className='col-lg-6 '>
              <Form.Group controlId='user.countryAccess'>
                <Form.Label className='fs--1'>
                  Country Access
                </Form.Label>
                <Form.Control
                  className='fs--1 form-control'
                  type='text'
                  size='sm'
                  disabled={profileDetails.partnerType !== 'liner'}
                  value={countryAccess}
                  onChange={(e) => {
                    setCountryAccess(e.target.value);
                    dispatch(setDirty());
                  }}
                />
              </Form.Group>
            </div> */}
        {  profileDetails.partnerType == 'liner'  &&
          <div className='col-lg-6 '>
              <Form.Group controlId='user.locationAccess'>
                <Form.Label className='fs--1'>
                  Location Access
                </Form.Label>
                <Form.Control
                  className='fs--1 form-control'
                  type='text'
                  size='sm'
                  disabled={profileDetails.partnerType !== 'liner'}
                  value={locationAccess}
                  onChange={(e) => {
                    setLocationAccess(e.target.value);
                    dispatch(setDirty());
                  }}
                />
              </Form.Group>
            </div>}
            <div className='d-flex justify-content-center align-items-center mt-4'>
              <Button
                type='submit'
                className='me-2'
                variant='falcon-danger'
                size='sm'
                disabled={!isDirty}
              >
                <FontAwesomeIcon icon={faFloppyDisk} className='me-2' />
                {t("resource_1:save")}
              </Button>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default User;
